// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__1Rg8h","important":"styles_important__3t5o3"};